export const localization = {
    actions: 'Действия',
    and: 'И',
    cancel: 'Отмена',
    changeFilterMode: 'Сменить режим фильтра',
    changeSearchMode: 'Сменить режим поиска',
    clearFilter: 'Очистить фильтр',
    filterByColumn: 'Фильтровать по полю "{column}"',
    clearSearch: 'Очистить поиск',
    clearSort: 'Отменить сортировку',
    clickToCopy: 'Кликнуть для копирования',
    search: 'Поиск',
    hideColumn: 'Скрыть поле "{column}"',
    showHideFilters: 'Показать/Скрыть фильтры',
    sortByColumnAsc: 'Сортировать по возрастанию поле "{column}"',
    sortByColumnDesc: 'Сортировать по убыванию поле "{column}"',
    sortedByColumnAsc: 'Отсортировано по полю {column} по возрастанию',
    sortedByColumnDesc: 'Отсортировано по полю {column} по убыванию',
    rowsPerPage: 'Показывать строк',
    resetColumnSize: 'Сбросить размер столбца',
    showAllColumns: 'Показать все столбцы',
    hideAll: 'Спрятать все',
    resetOrder: 'Сбросить сортировку',
    showHideSearch: 'Показать/Спрятать поиск',
    showHideColumns: 'Показать/Спрятать столбцы',
    showAll: 'Показать все',
    toggleDensity: 'Изменить плотность таблицы',
    move: 'Переместить',
    expand: 'Развернуть',
    collapse: 'Свернуть',
    noRecordsToDisplay: 'Нет записей для отображения',
    collapseAll: 'Свернуть все',
    expandAll: 'Развернуть все',
    columnActions: 'Действия со столбцами:',
    noResultsFound: 'Совпадений не найдено',
}